import slidesLVGP from './slides_LVGP';
import { featuresLVGP } from './features_LVGP';
import { ProjectType } from '../../Constants';
import { textLVGP } from './text_LVGP';

export const LVGPdata = {

    fr:{
        id: 2,
        name: 'LeVIVO GreenField Park',
        content: textLVGP.fr,
        yearBuilt: 2020,
        address: "80 Bd Churchill, Greenfield Park, QC J4V 0A9",
        city: "Greenfield Park",
        brand: "levivo",
        projectPage: "levivo/greenfield-park",
        website: "https://levivo.ca/en/rentals-condos/levivo-greenfield-park/",
        category: ProjectType.Residential,
        images: slidesLVGP,
        features: featuresLVGP.fr
    },
    en:{
        id: 2,
        name: 'LeVIVO GreenField Park',
        content: textLVGP.en,
        yearBuilt: 2020,
        address: "80 Bd Churchill, Greenfield Park, QC J4V 0A9",
        city: "Greenfield Park",
        brand: "levivo",
        projectPage: "levivo/greenfield-park",
        website: "https://levivo.ca/en/rentals-condos/levivo-greenfield-park/",
        category: ProjectType.Residential,
        images: slidesLVGP,
        features: featuresLVGP.en
    }
}
